export default __webpack_public_path__ + "static/media/custome.ac644bf4.png";